type Tab = { id: string; lastActiveAt: number | null };

export function mostRecentlyActiveTab<T extends Tab>(
  tabs: readonly T[]
): T | undefined {
  return tabs.reduce<T | undefined>(
    (best, t) =>
      !best || (t.lastActiveAt ?? 0) > (best.lastActiveAt ?? 0) ? t : best,
    undefined
  );
}

export function nextTabIdAfterClose({
  tabs,
  pendings,
  closedIds,
}: {
  tabs: readonly Tab[];
  pendings: readonly { id: string }[];
  closedIds: readonly string[];
}): string | null {
  const closed = new Set(closedIds);
  const remaining = mostRecentlyActiveTab(
    tabs.filter((t) => !closed.has(t.id))
  );
  if (remaining) return remaining.id;
  return pendings.find((p) => !closed.has(p.id))?.id ?? null;
}
